// Global
import { jsx as _jsx } from "react/jsx-runtime";
// Local
import ArticleCategoryTabsQuery from 'components/authorable/shared/page-specific/ArticleCategoryTabs.graphql';
import ArticleListingClient from './ArticleListingClient';
import graphqlClientFactory from 'lib/graphql-client-factory';
// Server-safe entry point (no 'use client'). Mirrors the Breadcrumb split:
// keeping `getComponentServerProps` and the Default in a server module so the
// webpack `component-props.loader` can strip the server-only export, and
// delegating rendering to a client module that reads its data from
// ComponentPropsContext via `useComponentProps(uid)` (App Router does not
// auto-inject `staticProps` into placeholder children).
export const Default = (props)=>{
    return /*#__PURE__*/ _jsx(ArticleListingClient, {
        ...props
    });
};
